module.exports = __webpack_public_path__ + "static/media/rsna18-top.df1b2e63.svg";